import React from 'react'
import TitleBar from '../ticket/components/TitleBar'
import TicketScanner from '../ticket/TicketScanner'

export default () =>
  <div id="app" className="ticket-scanner">
    <TitleBar />
    <div className="ticket-scanner-container">
      <TicketScanner />
    </div>
  </div>



// WEBPACK FOOTER //
// src/pages/TicketScannerPage.jsx